import {
  Backdrop, Button, Card, CardContent, CardHeader, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle,
  Divider, Grid, Input, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography,
  InputAdornment, TextField, FormControl, CardActions
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Page from 'src/components/Page';
import axios from "src/utils/axios";
import { CreateWareHouseAddress, getUser, sc } from 'src/utils/Common';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import PrintIcon from '@material-ui/icons/Print';
import BarcodeImage from 'src/components/BarcodeImage';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const defaultUyari = { open: false, aciklama: '', tip: 'success' };

function MyPassSend() {
  const classes = useStyles();
  const [Loading, setLoading] = React.useState(false);
  const [dataPaslasma, setPaslasmaData] = React.useState([]);
  const [uyari, setUyari] = React.useState(defaultUyari);
  const [pagination, setPagination] = React.useState({ page: 0, rowsPerPage: 10 });
  const user = getUser();
  const [search, setSearch] = React.useState('');
  const [passEditParam, setPassEditParam] = React.useState('');
  const [oldData, setoldData] = React.useState([]);
  const [Print, setPrint] = React.useState(false);
  const [Etiket, setEtiket] = React.useState('');
  const [Name, setName] = React.useState('');
  const [Phone, setPhone] = React.useState('');
  const [Address, setAddress] = React.useState('');
  const [KargoOdemeDurum, setKargoOdemeDurum] = React.useState('');
  const [containerHeight, setContainerHeight] = React.useState('auto');

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight;
      const headerHeight = document.querySelector('header').offsetHeight;
      const newHeight = windowHeight - headerHeight - 270; // 50 is a buffer for padding/margin
      setContainerHeight(newHeight);
    };

    handleResize(); // Initial call to set height

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(defaultUyari);
  };
  const handleSearch = (Param) => {
    setSearch(Param);

    setPaslasmaData(oldData.filter(item => sc(item.PASLASMA_NO, Param) || sc(item.SERVIS, Param) || sc(item.TALEP_EDEN, Param)
      || sc(item.TELEFON, Param)
      || sc(item.TARIH, Param)
      || sc(item.DURUM, Param)
      || sc(item.MALZEME_STOK_NO, Param)
      || sc(item.GONDERI_TIP, Param)
      || sc(item.GONDERI_KODU, Param)
    ))
  }


  const GetOpenPassByService = () => {
    setLoading(true);
    axios.get("GetOpenPassByService/5/" + user.ServiceShopId)
      .then(response => {
        // console.log(response);
        setPaslasmaData(response.data);
        setoldData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  useEffect(() => {
    CreateWareHouseAddress(user.ServiceShopId);
    GetOpenPassByService();
  }, []);

  function PassProcess(ISLEM_TIPI, ID) {
    confirmAlert({
      message: 'Paslaşma talebi iptal edilecektir. Devam etmek istediğinzden eminmisiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => PassProcessKabul(ISLEM_TIPI, ID)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }
  function PassProcessKabul(ISLEM_TIPI, ID) {
    setLoading(true);
    const data = {
      ISLEM_TIPI: ISLEM_TIPI,
      ID: ID,
      USERID: user.UserId
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetPassProcess', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });

  }




  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [passEdit, setPassEdit] = React.useState(false);

  const GetPassEditPopUp = (event, ID) => {
    setPassEditParam(ID);
    setPassEdit(true);
  }


  const [Envalue, setEnvalue] = React.useState();

  const handleEnInputChange = (event) => {
    setEnvalue(event.target.value === '' ? '' : event.target.value);
  };

  const [Boyvalue, setBoyvalue] = React.useState();

  const handleBoyInputChange = (event) => {
    setBoyvalue(event.target.value === '' ? '' : event.target.value);
  };

  const [Yukseklikvalue, setYukseklikvalue] = React.useState();

  const handleYukseklikInputChange = (event) => {
    setYukseklikvalue(event.target.value === '' ? '' : event.target.value);
  };

  const [Desivalue, setDesivalue] = React.useState();

  const handleDesiInputChange = (event) => {
    setDesivalue(event.target.value === '' ? '' : event.target.value);
  };

  const [KargoTutarvalue, setKargoTutarvalue] = React.useState();

  const handleKargoTutarInputChange = (event) => {
    setKargoTutarvalue(event.target.value === '' ? '' : event.target.value);
  };

  function SetKargoBilgisi() {
    const data = {
      EN: Envalue,
      BOY: Boyvalue,
      YUKSEKLIK: Yukseklikvalue,
      DESI: Desivalue,
      KARGO_TUTAR: KargoTutarvalue,
      ID: passEditParam,
      USERID: user.UserId
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetPassKargoBilgisi', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
        setPassEdit(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });
  }

  const GetTruck = (event, ID) => {
    var LinkTruck = process.env.REACT_APP_TRUCK_URL + ID;
    event.persist();
    window.open(LinkTruck);
    event.persist();
  }

  const GetPrintPopUp = (event, ID, Name, Phone, Address, KargoOdemeDurum) => {
    setEtiket(ID);
    setName(Name);
    setPhone(Phone);
    setAddress(Address);
    setKargoOdemeDurum(KargoOdemeDurum);
    setPrint(true);

  }
  const SetPrintParam = (event) => {
    var content = document.getElementById("dvPrint");
    let pri;
    const iframe = document.createElement('iframe')
    iframe.setAttribute('title', Etiket)
    iframe.setAttribute('id', Etiket)
    iframe.setAttribute('style', 'height: 0px; width: 0px; position: absolute;')
    document.body.appendChild(iframe);
    pri = iframe.contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();

  }


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title={' Sevk Edilenler'}></CardHeader>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Divider />
          <Snackbar open={uyari.open} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyari.tip}>
              {uyari.aciklama || ''}
            </Alert>
          </Snackbar>
          <CardActions>
            <FormControl fullWidth>
              <TextField
                label="Arama Yapınız..."
                value={search}
                className={clsx(classes.margin, classes.textField)}
                onChange={e => handleSearch(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </FormControl>
          </CardActions>
          <CardContent>
            <TableContainer className={classes.tableContainer} style={{ height: containerHeight }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    {/* <TableCell align="left">Güncelle</TableCell> */}
                    <TableCell align="left">İptal</TableCell>
                    <TableCell align="left">PaslaşmaNo</TableCell>
                    <TableCell align="left">Servis</TableCell>
                    <TableCell align="left">TicariÜnvan</TableCell>
                    <TableCell align="left">Telefon</TableCell>
                    <TableCell align="left">Tarih</TableCell>
                    <TableCell align="left">Durum</TableCell>
                    <TableCell align="left">MalzemeKodu</TableCell>
                    <TableCell align="left">Malzeme</TableCell>
                    <TableCell align="left">Adet</TableCell>
                    <TableCell align="left">GönderiTip</TableCell>
                    <TableCell align="left">GönderiKodu</TableCell>
                    <TableCell align="left">KargoÖdeme</TableCell>
                    <TableCell align="left">EtiketBas</TableCell>
                    <TableCell align="left">KargoTakip</TableCell>
                    <TableCell align="left">EFaturaNo</TableCell>
                    <TableCell align="left">Ödero</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataPaslasma.slice(pagination.page * pagination.rowsPerPage, (pagination.page + 1) * pagination.rowsPerPage).map((row, index) => (
                    <TableRow key={index}>

                      <TableCell align="left">
                        {
                          row.IPTAL === 0 ? '' : <DeleteForeverIcon
                            onClick={() => PassProcess(3, row.ID)}
                            color="error" />
                        }
                      </TableCell>
                      <TableCell align="left" >
                        {row.PASLASMA_NO}
                      </TableCell>
                      <TableCell align="left" >
                        {row.SERVIS}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TALEP_EDEN}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TELEFON}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TARIH}
                      </TableCell>
                      <TableCell align="left" >
                        {row.DURUM}
                      </TableCell>
                      <TableCell align="left" >
                        {row.MALZEME_STOK_NO}
                      </TableCell>
                      <TableCell align="left" >
                        {row.MALZEME_ACIKLAMA}
                      </TableCell>
                      <TableCell align="left">
                        {row.ADET}
                      </TableCell>
                      <TableCell align="left">
                        {row.GONDERI_TIP}
                      </TableCell>
                      <TableCell align="left">
                        {row.GONDERI_KODU}
                      </TableCell>
                      <TableCell align="left">
                        {row.KARGO_ODEME_DURUM}
                      </TableCell>
                      <TableCell align="left" >
                        <PrintIcon
                          onClick={(event) => GetPrintPopUp(event, row.ID, row.SERVIS, row.TELEFON, row.ACIK_ADRES, row.KARGO_ODEME_DURUM)}
                          color="primary" />
                      </TableCell>
                      <TableCell align="left" >
                        {row.GONDERI_TIP === 'Aras Kargo' ?
                          <LocalShippingIcon
                            onClick={(event) => GetTruck(event, row.ID)}
                            color="primary" />
                          : ''}
                      </TableCell>
                      <TableCell align="left">
                        {row.EFATURA_NO}
                      </TableCell>
                      <TableCell align="left">
                        {row.orderId}
                      </TableCell>



                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={dataPaslasma.length}
              rowsPerPage={pagination.rowsPerPage}
              page={pagination.page}
              onChangePage={(e, v) => setPagination({ ...pagination, page: v })}
              onChangeRowsPerPage={e => setPagination({ page: 0, rowsPerPage: e.target.value })}
            />
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={passEdit}
        onClose={() => setPassEdit(false)}
        keepMounted
        style={{ Width: 500, Height: 500, }}
      >
        <DialogTitle id="alert-dialog-title">
          Kargo Bilgileri
        </DialogTitle>

        <DialogContent>

          <div className={classes.root}>

            <Typography id="input-slider" gutterBottom>
              EN
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={Envalue}
                  margin="dense"
                  onChange={handleEnInputChange}
                />
              </Grid>
            </Grid>

            <Typography id="input-slider" gutterBottom>
              BOY
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={Boyvalue}
                  margin="dense"
                  onChange={handleBoyInputChange}
                />
              </Grid>
            </Grid>

            <Typography id="input-slider" gutterBottom>
              YÜKSEKLİK
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={Yukseklikvalue}
                  margin="dense"
                  onChange={handleYukseklikInputChange}
                />
              </Grid>
            </Grid>


            <Typography id="input-slider" gutterBottom>
              DESİ
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={Desivalue}
                  margin="dense"
                  onChange={handleDesiInputChange}
                />
              </Grid>
            </Grid>


            <Typography id="input-slider" gutterBottom>
              KARGO TUTAR
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={KargoTutarvalue}
                  margin="dense"
                  onChange={handleKargoTutarInputChange}
                />
              </Grid>
            </Grid>


          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => SetKargoBilgisi()}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Güncelle
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Print}
        onClose={() => setPrint(false)}
        maxWidth={'md'}
        keepMounted
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Etiket Bas
        </DialogTitle>
        <Divider />
        <DialogContent>
          {Etiket !== '' ? <div id='dvPrint'><BarcodeImage Barcode={Etiket} Name={Name} Phone={Phone} Address={Address} KargoOdemeDurum={KargoOdemeDurum} /></div> : ''}
        </DialogContent>
        <DialogActions>

          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => SetPrintParam(event)}
            className={classes.button}
            endIcon={<PrintIcon>Close</PrintIcon>}
          >
            Yazdır
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default MyPassSend;
